import {defineMessages} from 'react-intl';

export const messages = defineMessages({
    REPAIR_METHOD: {
        id: 'ase.issueOrigin.option.repairMethod',
        defaultMessage: 'Repair Method'
    },
    LABOR_TIME: {
        id: 'ase.issueOrigin.option.laborTime',
        defaultMessage: 'Labor Time'
    },
    EASY_BASKET: {
        id: 'ase.issueOrigin.option.easyBasket',
        defaultMessage: 'Easy Basket'
    }
});

export default messages;
